import moment from 'moment';
 
const DateFunctions = {

    GenerateUpdateText(latest){
        let output = 'Latest update...';
        let displayDate = Object.entries(latest[0])[0][1];
        const m = moment(displayDate);
        output = `Latest data as of ${m.format('LLLL')}`;
        return output;
    }, 

    FormatDate(input){
        const m = moment(input);
        return m.format('LLLL');
    }

}

export default DateFunctions;